export type DocumentTypeKey =
  | 'RG'
  | 'CNH'
  | 'COMPROVANTE_RESIDENCIA'
  | 'CARTAO_CNPJ'
  | 'ASO'
  | 'CERTIFICADO_MEI'
  | 'COMPROVANTE_BANCARIO'
  | 'FICHA_REGISTRO'
  | 'CERTIDAO_NASCIMENTO_FILHOS'
  | 'CERTIDAO_CASAMENTO'
  | 'DIPLOMAS_CERTIFICADOS'
  | 'CONTRATO_VINCULO'
  | 'GERAL'

export type DocumentStatus = 'PENDENTE' | 'N/A' | 'ENTREGUE' | 'VENCIDO' | 'VALIDO'

export interface ChecklistDocumentItem {
  key: DocumentTypeKey
  label: string
  defaultStatus: DocumentStatus
  regimeApplicable?: 'CLT' | 'PJ' | 'ALL'
}

export const BASE_CHECKLIST_DOCUMENTS: ChecklistDocumentItem[] = [
  { key: 'RG', label: 'RG', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'CNH', label: 'CNH', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'COMPROVANTE_RESIDENCIA', label: 'Comprovante de residência', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'CARTAO_CNPJ', label: 'Cartão CNPJ', defaultStatus: 'PENDENTE', regimeApplicable: 'PJ' },
  { key: 'ASO', label: 'ASO — Atestado de Saúde Ocupacional', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'CERTIFICADO_MEI', label: 'Certificado de MEI (ativo/inativo)', defaultStatus: 'PENDENTE', regimeApplicable: 'PJ' },
  { key: 'COMPROVANTE_BANCARIO', label: 'Comprovante bancário com dados', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'FICHA_REGISTRO', label: 'Ficha de registro', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'CERTIDAO_NASCIMENTO_FILHOS', label: 'Certidão de nascimento dos filhos', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'CERTIDAO_CASAMENTO', label: 'Certidão de casamento', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'DIPLOMAS_CERTIFICADOS', label: 'Diplomas e certificados (faculdade, NRs...)', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
  { key: 'CONTRATO_VINCULO', label: 'Contrato de vínculo', defaultStatus: 'PENDENTE', regimeApplicable: 'ALL' },
]

export interface UserFileAttachment {
  id?: number
  file?: File
  fileUrl?: string
  title: string
  fileName?: string
  documentType: DocumentTypeKey
  expirationDate?: string
  status?: DocumentStatus
  isEditing?: boolean
}
